import { FeatureNameEnum } from '../features';
import { NavigationItemInterface } from '../interfaces';
import { RoutesEnum } from '../routes';

export const downloadsNavigationItem: Readonly<NavigationItemInterface> = {
  name: FeatureNameEnum.Downloads,
  icon: 'download',
  route: `/${RoutesEnum.Downloads}`,
};
